import React, { useEffect, useState } from 'react';
import ZImage from 'sushiweb/ZImage';
import './multimedia.scss';
import { Modal } from '../../UiKit';
import { VideoPlayer } from '../videoPlayer/videoPlayer';
import Carousel from 'sushiweb/Carousel';
import Tag from 'sushiweb/Tag';
import { Icon } from '@grofers/dock-design-kit';

export const MultiMediaCarousel = (props) => {
  return (
    <div
      css={`
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
      `}
    >
      {(props.type === 'video' || props.type === 'VIDEO') && (
        <VideoPlayer
          src={props.src}
          css={`
            object-fit: contain;
          `}
        />
      )}
      {(props.type === 'image' || props.type === 'IMAGE') && (
        <ZImage
          src={props.src}
          width='100%'
          height='100%'
          css={`
            img {
              width: 100%;
              max-height: 600px;
              object-fit: contain;
              object-position: center;
              border-radius: 6px;
            }
          `}
          alt='Sample image'
          imgAlt='Sample image'
        />
      )}
    </div>
  );
};

export const MultiMedia = ({
  images,
  mediaStyle = {},
  title,
  showUploadMethod = false,
}) => {
  const [ind, setInd] = useState(0);
  const [isOpen, toggleOpen] = useState(false);

  useEffect(() => {
    setInd(0);
  }, [images, images?.length]);

  const handleClose = () => toggleOpen(false);

  const handleClick = (index) => () => {
    toggleOpen(true);
    setInd(index);
  };
  const handlePreviewClick = (index) => () => {
    setInd(index);
  };

  if (images.length === 0) return null;

  if (ind < 0 || ind > images?.length) return null;

  return (
    <div className='multiMediaViewer' data-dd-privacy='hidden'>
      <div
        className='tw-relative tw-h-96 tw-w-96 tw-overflow-hidden'
        style={{ ...mediaStyle }}
      >
        {(images[ind].type === 'video' || images[ind].type === 'VIDEO') && (
          <video
            src={images[ind].src}
            className='tw-size-full'
            style={{
              borderRadius: '6px',
              cursor: 'pointer',
              margin: 'auto',
            }}
            onClick={handleClick(ind)}
            controls
            muted
          />
        )}

        {(images[ind].type === 'image' || images[ind].type === 'IMAGE') && (
          <div className='tw-cursor-pointer tw-border tw-border-solid tw-border-[#e0e0e0] tw-rounded-lg tw-bg-grey-200 tw-shadow-md'>
            <ZImage
              src={images[ind].src}
              width='100%'
              height='100%'
              style={{
                borderRadius: '6px',
                cursor: 'pointer',
                margin: 'auto',
              }}
              onClick={handleClick(ind)}
              alt='Sample image'
              imgAlt='Sample image'
            ></ZImage>
          </div>
        )}

        {/* Upload method Tag  */}
        {showUploadMethod && (
          <div className='tw-absolute tw-bottom-[10px] tw-right-1/2 tw-transform tw-translate-x-[50%] tw-text-[14px] tw-font-medium'>
            <Tag
              label={`Upload Source: ${
                images[ind]?.upload_method
                  ? images[ind].upload_method
                  : 'Unknown'
              }`}
              textColor='#FFFFFF'
              bgColor='#434343'
            />
          </div>
        )}
      </div>

      {/* Media Array */}
      <div className='multiMediaList'>
        {images.map((image, index) => {
          return (
            <div
              key={index + image.src}
              className={`${
                index === ind ? 'activeMediaPreview' : 'inActiveMediaPreview'
              } tw-flex tw-gap-3`}
            >
              {(image.type === 'video' || image.type === 'VIDEO') && (
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                <div
                  className='tw-w-30 tw-h-24 tw-relative'
                  onClick={handlePreviewClick(index)}
                >
                  <video
                    src={image.src}
                    className='tw-size-full tw-border-2 tw-border-solid tw-border-grey-800 tw-cursor-pointer'
                    alt='comlaint_image'
                    muted
                  />
                  <Icon
                    className='tw-absolute tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-cursor-pointer'
                    iconColor={{ color: 'white', weight: '600' }}
                    name='play'
                    size='lg'
                  />
                </div>
              )}
              {(image.type === 'image' || image.type === 'IMAGE') && (
                <ZImage
                  src={image.src}
                  width='100%'
                  height='60px'
                  onClick={handlePreviewClick(index)}
                  alt='Sample image'
                  imgAlt='Sample image'
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Media viewer modal */}
      {isOpen && (
        <Modal
          isMaxContent
          maxHeight='82vh'
          isVisible={isOpen}
          type='large'
          title={title}
          handleClose={handleClose}
          containerStyles={{ padding: 'auto' }}
          component={
            <Carousel
              showComponent={true}
              componentData={images}
              componentToRender={MultiMediaCarousel}
              defaultTheme={false}
              currentIndex={ind}
              dots={false}
              infinite={false}
              width='100%'
            />
          }
        />
      )}
    </div>
  );
};
